define.alias("shared/components/shared/feature-upgrade-banner", "calendar/components/shared/feature-upgrade-banner");